'use es6';

export { default as deepLLogo } from 'bender-url!ContentComponents/img/DeepL-logo.png';
export { default as podcastZeroImage } from 'bender-url!ContentComponents/img/podcast-zero.png';
export { default as caseStudyZeroImage } from 'bender-url!ContentComponents/img/case-study-zero.png';
export { default as landingPageZeroImage } from 'bender-url!ContentComponents/img/landing-page-zero.png';
export { default as websitePageZeroImage } from 'bender-url!ContentComponents/img/website-page-zero.svg';
export { default as blogPostZeroImage } from 'bender-url!ContentComponents/img/blog-post-zero.png';
export { default as paymentMethodsImage } from 'bender-url!ContentComponents/img/payment_methods.png';
export { default as noThemeImage } from 'bender-url!ContentComponents/img/no-theme.png';
import contentRemixPostPublishEn from 'bender-url!ContentComponents/img/content-remix-post-publish/content-remix-en.png';
import contentRemixPostPublishDe from 'bender-url!ContentComponents/img/content-remix-post-publish/content-remix-de.png';
import contentRemixPostPublishFr from 'bender-url!ContentComponents/img/content-remix-post-publish/content-remix-fr.png';
import contentRemixPostPublishJa from 'bender-url!ContentComponents/img/content-remix-post-publish/content-remix-ja.png';
import contentRemixPostPublishPt from 'bender-url!ContentComponents/img/content-remix-post-publish/content-remix-pt.png';
export const ContentRemixPostPublishImages = {
  contentRemixPostPublishDe,
  contentRemixPostPublishEn,
  contentRemixPostPublishFr,
  contentRemixPostPublishJa,
  contentRemixPostPublishPt
};